import type { CSSProperties } from 'react';
import type { CdropdownProps } from '../Cdropdown';
import type { CinputshellProps } from '../Cinputshell';

export enum CtextinputDataName {
  Wrapper = 'wrapper',
  DropdownText = 'dropdownText',
  Textarea = 'textarea',
  Input = 'input',
  ErrorText = 'errorText',
}

export enum CtextinputInputType {
  Text = 'text',
}

export enum CtextinputAutoComplete {
  Off = 'off',
}

export enum CtextinputChevronTransform {
  Open = 'rotate(180deg)',
  Closed = 'rotate(0deg)',
}

export const CTEXTINPUT_RESIZE_NONE = 'none';
export const RTL_INPUT_STYLE: CSSProperties = { direction: 'rtl' };
export const LTR_INPUT_STYLE: CSSProperties = { direction: 'ltr' };
export const CTEXTINPUT_SELECT_PLACEHOLDER = 'Select';
export const CTEXTINPUT_SELECT_LABEL_PREFIX = 'Select ';
export const CTEXTINPUT_DROPDOWN_OPEN_DIRECTION_AUTO: NonNullable<
  CdropdownProps['openDirection']
> = 'auto';
export const CTEXTINPUT_DROPDOWN_ALIGN_CENTER: NonNullable<CdropdownProps['align']> =
  'center';
export const CTEXTINPUT_DROPDOWN_JUSTIFY_CONTENT: CinputshellProps['justifyContent'] =
  'space-between';
export const CTEXTINPUT_TEXTUAL_JUSTIFY_CONTENT: CinputshellProps['justifyContent'] =
  'flex-start';

export const DROPDOWN_WIDTH_PX = 370;
export const DROPDOWN_MAX_HEIGHT_PX = 264;
export const DROPDOWN_CHEVRON_RIGHT_OFFSET_PX = 30;
export const DEFAULT_PADDING_RIGHT_PX = 15;
export const DEFAULT_PADDING_BLOCK_PX = 8;
export const DEFAULT_PADDING_LEFT_PX = 15;
export const CTEXTINPUT_LABEL_GAP_PX = 6;
export const CTEXTINPUT_DEFAULT_FONT_SIZE_PX = 17;
export const CTEXTINPUT_LABEL_FONT_SIZE_PX = 16;
export const CTEXTINPUT_ERROR_FONT_SIZE_PX = 14;
export const CTEXTINPUT_DROPDOWN_LINE_HEIGHT = 1;
export const CTEXTINPUT_FIELD_LINE_HEIGHT = 1.5;
export const CTEXTINPUT_TEXTAREA_ROW_HEIGHT_REM = 1.5;
export const CTEXTINPUT_TEXTAREA_EXTRA_HEIGHT_REM = 1;
export const CTEXTINPUT_MULTILINE_MARGIN = '15px 0';
export const CTEXTINPUT_CHEVRON_SIZE_PX = 20;
export const CTEXTINPUT_CHEVRON_TRANSITION = 'transform 200ms ease-in-out';
export const CTEXTINPUT_TEXT_DISABLED_OPACITY = 0.55;
export const CTEXTINPUT_TEXT_ACTIVE_OPACITY = 1;
export const CTEXTINPUT_TEXT_RESTING_OPACITY = 0.9;
export const CTEXTINPUT_DROPDOWN_PLACEHOLDER_OPACITY = 0.5;
export const CTEXTINPUT_CHEVRON_DISABLED_OPACITY = 0.3;
export const CTEXTINPUT_CHEVRON_ENABLED_OPACITY = 0.5;
